import React from "react";
import {
  Badge,
  Button,
  Col,
  Container,
  Nav,
  Navbar,
  Row,
  Stack,
  Carousel,
} from "react-bootstrap";
import {DUI_Quote_FORM_v01, heroImages, imagePath, API_URL } from "../../component-library/QUOTE-FORMS/DUI_Insurance_FORM_v01";



const CLIENT_VERSION = "v04" as const; // 2025-08-26
const TEST_MODE = false;




const theme = {
  brand: {
    name: "Dollar Pet Insurance",
    domain: "DollarPetInsurance.com",
    primaryHex: "#198754",
    secondaryHex: "#0d6efd",
  },
  ui: {
    heroBgHeight: "min(80vh, 720px)",
    cardShadow: "0 8px 24px rgba(0,0,0,0.08)",
  },
} as const;

export const DUI_InsuranceLanding_v04_Carousel: React.FC = () => {
  return (
    <div style={{ background: "#fff" }}>
      {/* NAVBAR */}
      <Navbar bg="light" expand="lg" sticky="top" style={{ boxShadow: "0 2px 10px rgba(0,0,0,0.06)" }}>
        <Container>
          <Navbar.Brand href="#home" className="fw-bold">
            <span style={{ color: theme.brand.primaryHex }}>$</span> {theme.brand.name}
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="dpi-nav" />
          <Navbar.Collapse id="dpi-nav">
            <Nav className="ms-auto" navbarScroll>
              <Nav.Link href="#quote">Get Quote</Nav.Link>
              <Nav.Link href="#benefits">Benefits</Nav.Link>
              <Nav.Link href="#coverage">Coverage</Nav.Link>
              <Nav.Link href="#pricing">Pricing</Nav.Link>
              <Nav.Link href="#faq">FAQ</Nav.Link>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* HERO */}
      <section id="home" className="py-5" style={{ position: "relative", overflow: "hidden" }}>
        <div
          aria-hidden="true"
          style={{ position: "absolute", inset: 0, height: theme.ui.heroBgHeight, zIndex: 0 }}
        >
          <Carousel controls indicators interval={3000} fade>
            {heroImages.map((img, i) => (
              <Carousel.Item key={i}>
                <img
                  className="d-block w-100"
                  src={imagePath + img.src}
                  alt={img.alt}
                  style={{
                    height: theme.ui.heroBgHeight,
                    objectFit: "cover",
                    filter: "brightness(0.7)",
                  }}
                />
              </Carousel.Item>
            ))}
          </Carousel>
        </div>

        <div
          aria-hidden="true"
          style={{
            position: "absolute",
            inset: 0,
            height: theme.ui.heroBgHeight,
            background: "linear-gradient(0deg, rgba(0,0,0,0.35), rgba(0,0,0,0.15))",
            zIndex: 1,
          }}
        />

        <Container style={{ position: "relative", zIndex: 2 }}>
          <Row className="align-items-center g-4 justify-content-between" style={{ minHeight: theme.ui.heroBgHeight }}>
            {/* LEFT TEXT */}
            <Col md={6} lg={5}>
              <h1 className="display-5 fw-bold mb-3 text-white">
                Affordable Pet Insurance — Simple, Fast, Trusted
              </h1>
              <p className="lead mb-4" style={{ color: "rgba(255,255,255,0.9)" }}>
                Protect your best friend from the unexpected. Transparent plans,
                flexible deductibles, and fast claims.
              </p>
              <Stack direction="horizontal" gap={3} className="mb-4">
                <Badge bg="success">Best for Budgets</Badge>
                <Badge bg="primary">Fast Claims</Badge>
                <Badge bg="secondary">Vet of Your Choice</Badge>
              </Stack>
              <div className="d-flex gap-2">
                <Button href="#quote" size="lg" variant="success">Get My Quote</Button>
                <Button href="#benefits" size="lg" variant="outline-light">See Benefits</Button>
              </div>
            </Col>

            {/* RIGHT FORM */}
            <Col md={6} lg={5} id="quote" className="ms-auto">
              
              

              <DUI_Quote_FORM_v01
                clientVersion={CLIENT_VERSION}
                testMode={TEST_MODE}
                apiUrl={API_URL}
                themeCardShadow={theme.ui.cardShadow}
              />


            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
};

export default DUI_InsuranceLanding_v04_Carousel;
